/* eslint-disable @stylistic/max-len */
import { addEntriesFields } from '../endpoint-fields/add-entries.fields';
import { cartFields } from '../endpoint-fields/cart.fields';
import { relayFields } from '../endpoint-fields/relay-points.fields';
import { orderDetailsFields } from '../endpoint-fields/order-details.fields';
import { orderReturnFields } from '../endpoint-fields/order-return.fields';
import { storeSearchFields } from '../endpoint-fields/stores.fields';
import { productCardFields } from '../endpoint-fields/product-card.fields';
import { productDetailsFields } from '../endpoint-fields/product-details.fields';
import { productComparatorFields } from '../endpoint-fields/product-comparator.fields';
import { productFaqFields } from '../endpoint-fields/product-faq.fields';
import { productIfuFields } from '../endpoint-fields/product-ifu.fields';
import { productAccessoryFields } from '../endpoint-fields/product-accessory.fields';
import { productSearchFields } from '../endpoint-fields/product-search.fields';
import { recipeRangeSearchFields } from '../endpoint-fields/recipe-range-search.fields';
import { bundleCardsAndProducts, bundleNameAndUrlFields, bundlePriceFields } from '../endpoint-fields/bundle.field';
import { categoryCssHierarchyFields } from '../endpoint-fields/category-css-hierarchy.field';
import { categoryFields } from '../endpoint-fields/categories.fields';
import { priceFields } from '../endpoint-fields/price.fields';
import { liveBaseStoreFields } from '../endpoint-fields/live-base-store.fields';
import { productPriceStockFields } from '@seb/web-common/core/config/endpoint-fields/product-price-and-stock.fields';

export const backendConfig = {
  occ: {
    endpoints: {
      /*** CART ***/
      addEntries: 'users/${userId}/carts/${cartId}/entries?fields=' + addEntriesFields.join(','),
      addEntriesEmpty: 'users/${userId}/carts/${cartId}/entries',
      updateEntriesBundle: 'users/${userId}/carts/${cartId}/entries/bundle/${bundleId}',
      carts: 'users/${userId}/carts?fields=carts(' + cartFields.join(',') + ')',
      cart: 'users/${userId}/carts/${cartId}?fields=' + cartFields.join(','),
      relay: 'users/${userId}/carts/${cartId}/relay?fields=' + relayFields.join(','),
      nShiftRelay: 'users/${userId}/carts/${cartId}/nshift/relay?fields=' + relayFields.join(','),
      createCart: 'users/${userId}/carts?fields=' + cartFields.join(','),
      coupon: 'users/${userId}/carts/${cartId}/coupons/${couponId}',
      checkoutBillingAddress: 'users/${userId}/carts/${cartId}/addresses/billing?fields=DEFAULT',
      checkoutDeliveryAddress: 'users/${userId}/carts/${cartId}/addresses/delivery?fields=DEFAULT',
      checkoutGuest: 'users/${userId}/carts/${cartId}/guestemail',
      abandonedCart: 'users/${userId}/carts/${cartId}/email/add',
      relayPoint: 'users/${userId}/carts/${cartId}/relays',
      relayPointDeliveryInformation: 'users/${userId}/carts/${cartId}/relay/deliverydetails',
      addBundle: 'users/${userId}/carts/${cartId}/entries/bundle?fields=FULL',
      paymentModes: 'users/${userId}/carts/${cartId}/paymentmodes?fields=DEFAULT',
      paymentMode: 'users/${userId}/carts/${cartId}/paymentmode',
      deliveryModes: 'users/${userId}/carts/${cartId}/deliverymodes?fields=FULL',
      deliveryMode: 'users/${userId}/carts/${cartId}/deliverymode',
      deleteWithdrawalAddress: '/users/${userId}/carts/${cartId}/addresses/depositWithdrawalAddress',
      taxNumber: '/users/${userId}/carts/${cartId}/taxnumber',
      validateAddress: '/users/${userId}/carts/${cartId}/validateAddresses',
      updateExtendedWarranty: '/users/${userId}/carts/${cartId}/entries/${entryNumber}/extendedWarranty',

      /*** ORDERS ***/
      validateCartForPlaceOrder: '/users/${userId}/orders/validateCart',
      orderDetail: 'users/${userId}/orders/${orderId}?fields=' + orderDetailsFields.join(','),
      orderReturnForm: 'users/${userId}/orders/${orderId}/consignments/${consignmentId}/returns/form?fields=' + orderReturnFields.join(','),
      orderReturnReasons: 'refundreasons',
      orderReturnSubmit: 'users/${userId}/orders/${orderId}/consignments/${consignmentId}/returns/submit?fields=' + orderReturnFields.join(','),
      saveOrderProducts: 'users/${userId}/orders/${orderId}/registerProducts?fields=DEFAULT',
      invoiceOrder: 'users/${userId}/orders/${orderId}/invoice',

      /*** STORES ***/
      stores: 'stores?fields=' + storeSearchFields.join(','),
      detachedPieces: 'products/${productCode}?fields=detachedPieces(' + productCardFields.join(',') + ')',

      /*** PRODUCTS ***/
      product: {
        price: 'products/${productCode}?fields=' + priceFields.join(','),
        details: 'products/${productCode}?fields=' + productDetailsFields.join(','),
        card: 'products/${productCode}?fields=' + productCardFields.join(','),
        comparator: 'products/${productCode}?fields=' + productComparatorFields.join(','),
        categories: 'products/${productCode}?fields=categories',
        faq: 'products/${productCode}?fields=' + productFaqFields.join(','),
        ifu: 'products/${productCode}?fields=' + productIfuFields.join(','),
        accessoryHome: 'products/${productCode}?fields=' + productAccessoryFields.join(','),
        accessories: 'products/${productCode}?fields=accessories(' + productCardFields.join(',') + ')',
        priceAndStock: 'products/${productCode}?fields=' + productPriceStockFields.join(',')
      },
      productSearch: 'products/search?fields=' + productSearchFields.join(','),
      recipeRangeSearch: 'products/search?fields=' + recipeRangeSearchFields.join(','),
      productMinimalSearch: 'products/search?fields=pagination(totalResults),products(url,indexedBundles(id))',
      productNotificationSubmit: 'products/${productCode}/stockAlert',
      range: 'products/${productCode}/range/associatedProducts',
      bundles: 'products/${productCode}?fields=bundles',

      /*** BUNDLE ***/
      bundle: 'bundle/${bundleCode}?fields=FULL,products(FULL)',
      bundlePrice: 'bundle/${bundleCode}?fields=' + bundlePriceFields.join(','),
      bundleProductsPrice: 'bundle/${bundleCode}?fields=products(price),id',
      bundleNameAndUrl: 'bundle/${bundleCode}?fields=' + bundleNameAndUrlFields.join(','),
      bundleCardsAndProducts: 'bundle/${bundleCode}?fields=' + bundleCardsAndProducts.join(','),

      /*** USER ***/
      userUid: 'users/${userId}?fields=uid',
      user: 'users/${userId}?fields=FULL',
      userToken: 'users/${userId}/contactFormToken',

      /*** ADDRESS ***/
      address: 'users/${userId}/addresses?fields=FULL',
      updateAddress: 'users/${userId}/addresses/${addressId}?fields=FULL',
      mainAddress: 'users/${userId}/addresses/${addressId}/main',
      addressForm: 'countries/${countyIsoCode}/addressFormDefinition',
      contactInfoForm: 'countries/${countyIsoCode}/contactInfoFormDefinition',

      /*** BASESTORE ***/
      baseSites: 'basesites?fields=baseSites(uid,defaultLanguage(isocode),urlEncodingAttributes,urlPatterns,stores(uid,currencies(isocode),defaultCurrency(isocode),languages(isocode),defaultLanguage(isocode),houseOfBrandConfig),theme,defaultPreviewCatalogId,defaultPreviewCategoryCode,defaultPreviewProductCode)',
      baseStore: 'basestores/${baseStoreId}?fields=FULL',
      liveBaseStore: 'basestores/${baseStoreId}?fields=' + liveBaseStoreFields.join(','),
      geolocationKey: 'basestores/geolocationkey',
      cssHierarchy: 'basestores/csshierarchy?fields=FULL',
      categoryCssHierarchy: `basestores/csshierarchy?fields=accessoryCategory(${categoryCssHierarchyFields.join(',')})`,
      tmsScripts: 'basestores/tmsscripts',

      /*** CATEGORIES ***/
      categories: 'categories/${categoryCode}?fields=' + categoryFields.join(','),

      /*** FAQS ***/
      faqsNotUsefulReasons: 'faqs/notusefulreasons',
      faqsVote: 'faqs/${faqCode}/vote',

      /*** SEARCH ***/
      searchAutocomplete: 'search/autocomplete',
      searchRichAutocomplete: 'search/richautocomplete?fields=FULL',
      productsSearch: 'products/search?fields=FULL',
      globalSearch: 'search?fields=FULL',

      /*** SURVEYS ***/
      survey: 'surveys/${surveyCode}',
      surveyNext: 'surveys/${surveyCode}/${responseCode}/next?fields=FULL',

      /*** URL MAPPING ***/
      urlMappings: 'urlmapping',

      /*** ADYEN ***/
      adyenMethods: 'users/${userId}/orders/${orderCode}/payment/adyen/methods',
      adyenProcess: 'users/${userId}/orders/${orderCode}/payment/adyen/do',
      adyenDetails: 'users/${userId}/orders/${orderCode}/payment/adyen/details',
      adyenContinue: 'orders/${orderCode}/payment/adyen/continue',
      adyenDonation: 'users/${userId}/orders/${orderCode}/donations',
      adyenDonationCampaigns: 'users/${userId}/orders/${orderCode}/donationCampaigns',
      adyenExpressCheckoutPaymentModes: 'users/${userId}/carts/${cartId}/adyen/express-checkout/payment-modes?fields=FULL',
      adyenExpressCheckoutDeliveryModes: 'users/${userId}/carts/${cartId}/adyen/express-checkout/delivery-modes?fields=FULL',
      adyenExpressCheckoutUpdatePaypalOrder: 'users/${userId}/carts/${cartId}/adyen/express-checkout/paypal/update-order',
      adyenProcessPaypal: 'users/${userId}/cart/${cartId}/payment/paypal/adyen/do',

      /*** REPAIRERS */
      repairers: 'stores/search?fields=FULL',

      /*** REPAIRABILITY ***/
      repairabilityAutocomplete: 'repairability/autocomplete',
      repairabilitySearch: 'repairability/search?fields=FULL',

      /*** CAPTCHA ***/
      captchaKey: 'basestores/reCaptchakey',
      verifyCaptcha: 'basestores/verifyReCaptcha',

      /*** TITLES ***/
      titles: 'titles',

      /*** ONEY ***/
      oneyConfig: 'oney/configuration',
      oneySimulationProduct: 'product/${productCode}/simulations',
      oneySimulationBundle: 'bundle/${bundleId}/simulations',
      oneySimulationCart: 'users/${userId}/carts/${cartId}/simulations',

      /*** KLARNA ***/
      klarna: 'klarna/configuration?fields=DEFAULT',

      /*** CROSS SELL ***/
      accessoryCross: '/products/${code}/otherRecommendedAccessories?pageSize=${pageSize}&fields=FULL&page=${page}',
      cartCrossSell: 'users/${userId}/carts/${cartId}/crosssell?fields=' + productCardFields.join(',') + '',

      /*** PRODUCTS' ACCESSORIES ***/
      productsAccessories: '/products/accessories?fields=FULL',

      /*** PRODUCTS' ACCESSORIES BY TYPE ***/
      productsAccessoriesByType: '/products/accessoriesByType?fields=FULL',
      productAccessoriesOrderedByType: '/products/accessoriesOrderedByType?fields=FULL',

      /*** TRANSLATIONS ***/
      translations: '/localizedMessages/${language}',

      /*** NewsLetter ***/
      newsLetterForm: 'countries/${countyIsoCode}/newsLetterFormDefinition',

      /*** SEO ***/
      baseUrl: 'seo/base-url'
    }
  }
};
